// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"509":"177bcb70","702":"2c90259a","874":"2c90259a"}[chunkId] + ".chunk.css";
};